import React from 'react';
import { EVENT_LABELS } from './constants';
import { StatusPill } from './LegalBoardPrimitives';
import LegalBoardCertificateDocument from './LegalBoardCertificateDocument';
import {
    changeTypeLabel,
    describeEventDetails,
    formatDateCa,
    formatDateTimeCa,
    gencatStatusLabel,
    lifecycleLabel,
    memberFullName,
    stripeStatusLabel,
} from './legalBoardUi';

const lifecycleTone = (status) => {
    if (status === 'current') return 'success';
    if (status === 'draft') return 'warning';
    if (status === 'cancelled') return 'neutral';
    return 'info';
};

function LegalBoardHistory({ history, userId, embedded = false }) {
    const terms = Array.isArray(history) ? history : [];

    return (
        <section className={embedded ? 'legal-board-history' : 'legal-board-card legal-board-history'} aria-label="Historial de la junta legal">
            {embedded ? null : <h3>Historial</h3>}
            <p className="legal-board-muted legal-board-small">
                Cada mandat es conserva tal com es va registrar; les correccions queden anotades.
            </p>
            {terms.length === 0 ? <p className="legal-board-muted">Encara no hi ha cap mandat registrat.</p> : null}
            {terms.map((term) => (
                <article key={term.id} className="legal-board-history-term">
                    <header className="legal-board-history-head">
                        <div>
                            <h4>{changeTypeLabel(term.changeType)}</h4>
                            <p className="legal-board-muted legal-board-small">
                                {term.assemblyDate ? `Assemblea del ${formatDateCa(term.assemblyDate)} · ` : ''}
                                {term.mandateStart ? `Mandat des del ${formatDateCa(term.mandateStart)}` : 'Sense data d\'inici'}
                                {term.mandateEnd ? ` fins al ${formatDateCa(term.mandateEnd)}` : ''}
                                {` · Generalitat: ${gencatStatusLabel(term.gencatStatus)} · Stripe: ${stripeStatusLabel(term.stripeStatus)}`}
                            </p>
                        </div>
                        <StatusPill tone={lifecycleTone(term.lifecycleStatus)}>{lifecycleLabel(term.lifecycleStatus)}</StatusPill>
                    </header>

                    {term.certificateDocument && term.lifecycleStatus !== 'current' ? <LegalBoardCertificateDocument term={term} userId={userId} /> : null}
                    <div className="legal-board-history-columns">
                        <ul className="legal-board-member-list compact" aria-label="Composició">
                            {(term.members || []).length === 0 ? <li className="legal-board-muted">Sense membres.</li> : null}
                            {(term.members || []).map((member) => (
                                <li key={member.id || `${member.legalFirstName}-${member.legalLastName}`}>
                                    <span className="legal-board-member-name">{memberFullName(member)}</span>
                                    <span className="legal-board-member-role">{member.roleLabel || 'Sense càrrec'}</span>
                                </li>
                            ))}
                        </ul>
                        <ol className="legal-board-timeline" aria-label="Actuacions">
                            {(term.events || []).length === 0 ? <li className="legal-board-muted">Sense actuacions registrades.</li> : null}
                            {(term.events || []).map((event) => {
                                const details = describeEventDetails(event);
                                return (
                                    <li key={event.id} className="legal-board-timeline-item">
                                        <span className="legal-board-timeline-label">{EVENT_LABELS[event.type] || event.type}</span>
                                        <span className="legal-board-timeline-meta">
                                            {formatDateTimeCa(event.createdAt)}{event.actorName ? ` · ${event.actorName}` : ''}
                                        </span>
                                        {details ? <span className="legal-board-timeline-details">{details}</span> : null}
                                    </li>
                                );
                            })}
                        </ol>
                    </div>
                </article>
            ))}
        </section>
    );
}

export default LegalBoardHistory;
